import { ArrowLeft } from "lucide-react"

interface QuizHeaderProps {
  current: number
  total: number
  /** Show the `n/total` pill and progress bar. Off for uncounted steps (interstitials, email). */
  showCounter?: boolean
  showBack: boolean
  onBack: () => void
}

/** Navbar (back arrow + step counter) and progress bar shared by every quiz screen. */
export function QuizHeader({ current, total, showCounter = true, showBack, onBack }: QuizHeaderProps) {
  const progress = total > 0 ? current / total : 0

  return (
    <header data-slot="quiz-header" className="sticky top-0 z-20 w-full bg-dark-base">
      <div className="flex h-14 items-center justify-between px-4">
        {showBack ? (
          <button
            type="button"
            onClick={onBack}
            aria-label="Go back"
            className="-ml-2 flex size-10 items-center justify-center rounded-full text-purple-light transition-colors hover:bg-purple-light/10"
          >
            <ArrowLeft className="size-6" />
          </button>
        ) : (
          <span className="size-10" />
        )}
        {showCounter && (
          <div className="flex h-9 items-center justify-center rounded-full border border-purple-light/20 px-4 text-sm">
            <span className="font-semibold text-purple-light">{current}</span>
            <span className="px-1 text-purple-light/40">/</span>
            <span className="font-semibold text-purple-light">{total}</span>
          </div>
        )}
      </div>
      {showCounter && (
        <div className="h-1 w-full bg-purple-light/20">
          <div
            className="h-full bg-main-purple transition-all duration-300"
            style={{ width: `${progress * 100}%` }}
          />
        </div>
      )}
    </header>
  )
}
